const SupportBanner = () => (
  <div className="support-banner">
    <div className="support-content">
      <div className="support-icon">?</div>
      <div className="support-text">
        Need help with connecting WhatsApp?{' '}
        <a
          href="https://help.elfo.com/"
          className="highlight"
          target="_blank"
          rel="noopener noreferrer"
        >
          Talk to our Support
        </a>{' '}
        Team now!
      </div>
    </div>
  </div>
);

export default SupportBanner;
